export default __webpack_public_path__ + "static/media/u_wdt_c_0.4368b55b.mp3";